/* DAY BY DAY / First-visit RESERVE background: random salon hero per page view.
 * Other pages remain untouched because they have no data-aw-reserve-random-salon attribute.
 * If JS or salon photos are unavailable, the configured background remains as a fallback.
 */
(function () {
  'use strict';

  function initialize(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-aw-reserve-random-salon]')) roots.push(scope);
    roots.push.apply(roots, Array.from(scope.querySelectorAll('[data-aw-reserve-random-salon]')));

    roots.forEach(function (root) {
      if (root.dataset.awRandomSalonReady === 'true') return;
      var json = root.querySelector('[data-aw-reserve-random-images]');
      var image = root.querySelector('.aw-reserve-cta__picture .aw-reserve-cta__image');
      var source = root.querySelector('.aw-reserve-cta__picture source');
      if (!json || !image) return;

      var photos;
      try {
        photos = JSON.parse(json.textContent || '[]');
      } catch (error) {
        console.error('[DAY BY DAY random salon image] Invalid data', error);
        return;
      }
      if (!Array.isArray(photos) || !photos.length) return;

      var selection = photos[Math.floor(Math.random() * photos.length)];
      if (!selection || !selection.pc || !selection.sp) return;

      root.dataset.awRandomSalonReady = 'true';
      root.dataset.awSelectedSalon = selection.salon || '';
      if (source) {
        source.srcset = selection.sp;
        source.sizes = '100vw';
      }
      image.srcset = selection.pc;
      image.src = selection.pc;
      image.sizes = '100vw';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();